if (!customElements.get("m-collection-list")) {
  class e extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      (this.selectors = {
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper",
      }),
        (this.domNodes = queryDomNodes(this.selectors, this)),
        (this.enableSlider = "true" === this.dataset.enableSlider),
        (this.items = this.dataset.items),
        (this.total = this.dataset.total),
        (this.autoplay = "true" === this.dataset.autoplay),
        (this.autoplaySpeed = this.dataset.autoplaySpeed),
        (this.paginationType = this.dataset.paginationType),
        (this.expanded = "true" === this.dataset.expanded),
        (this.mobileDisableSlider =
          "true" === this.dataset.mobileDisableSlider),
        this.initByScreenSize(),
        document.addEventListener("matchMobile", () => {
          this.initByScreenSize();
        }),
        document.addEventListener("unmatchMobile", () => {
          this.initByScreenSize();
        });
    }
    initByScreenSize() {
      if (!this.enableSlider) return;
      const { slideContainer: e, slideControls: t } = queryDomNodes(
        this.selectors,
        this
      );
      MinimogTheme.config.mqlMobile && this.mobileDisableSlider
        ? (t?.classList.add("m:hidden"),
          e.classList.remove("swiper-container"),
          this.swiper && this.swiper.destroy(!1, !0))
        : (t?.classList.remove("m:hidden"), this.initSlider());
    }
    initSlider() {
      const { slideContainer: e } = queryDomNodes(this.selectors, this);
      e?.classList.add("swiper-container");
      this.slider = new MinimogLibs.Swiper(e, {
        slidesPerView: 2,
        loop: !0,
        slidesPerGroup: 1,
        showNavigation: !0,
        showPagination: !0,
        parallax: !0,
        autoplay: !!this.autoplay && {
          delay: 1e3 * parseInt(this.autoplaySpeed),
        },
        pagination:
          "fraction" == this.paginationType
            ? {
                el: this.querySelector(".swiper-pagination"),
                clickable: !0,
                type: "fraction",
              }
            : {
                el: this.querySelector(".swiper-pagination"),
                clickable: !0,
                bulletClass: "m-dot",
                bulletActiveClass: "m-dot--active",
                renderBullet: function (e, t) {
                  return (
                    '<span class="' +
                    t +
                    '"><svg width="65px" height="65px" viewBox="0 0 72 72" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><circle class="time" stroke-width="5" fill="none" stroke-linecap="round" cx="33" cy="33" r="28"></circle></svg></span>'
                  );
                },
              },
        autoHeight: !0,
        breakpoints: {
          480: { slidesPerView: 3 },
          768: {
            slidesPerView:
              parseInt(this.items) >= 7.5 ? 7.5 : parseInt(this.items),
          },
          1280: {
            slidesPerView:
              this.expanded && this.total > this.items
                ? parseInt(this.items) + 1
                : parseInt(this.items),
          },
        },
        on: {
          init() {
            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));
            }, 100);
          },
        },
      });
      const t = this.querySelector(".m-slider-controls"),
        i = t && t.querySelector(".m-slider-controls__button-prev"),
        s = t && t.querySelector(".m-slider-controls__button-next");
      this.slider &&
        i &&
        s &&
        (i && i.addEventListener("click", () => this.slider.slidePrev()),
        s && s.addEventListener("click", () => this.slider.slideNext())),
        (this.swiper = e?.swiper);
    }
  }
  customElements.define("m-collection-list", e);
}
